var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_60",
    x: 0,
    y: 0,
    width: 220,
    height: 220,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.286 -0.286)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_60-2",
    x: 11,
    y: 11,
    width: 198,
    height: 198,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61-2",
    "data-name": "Ellipse 61",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(0.272 0.272)",
    fill: "#383c50"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hero",
    transform: "translate(-69 -34)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "John_Doe",
    "data-name": "John Doe",
    transform: "translate(179 219)",
    fill: "#383c50",
    fontSize: 23,
    fontFamily: "Arial",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -77,
    y: 0
  }, "Set Profile Pic")), /*#__PURE__*/React.createElement("text", {
    id: "San_Francisco_CA",
    "data-name": "San Francisco, CA",
    transform: "translate(179 235)",
    fill: "#747474",
    fontSize: 14,
    fontFamily: "Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -95,
    y: 0
  }, "Tap to allow access to camera.")), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(-10 -504)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 79, 538)",
    filter: "url(#Ellipse_60)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60-3",
    "data-name": "Ellipse 60",
    cx: 65,
    cy: 65,
    r: 65,
    transform: "translate(45 25)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(1.431 -492.569)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 67.57, 526.57)",
    filter: "url(#Ellipse_60-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60-4",
    "data-name": "Ellipse 60",
    cx: 54,
    cy: 54,
    r: 54,
    transform: "translate(56 36)",
    fill: "#383c50"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(160.5 106.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M18,7.5v21",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M7.5,18h21",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImage);
export default __webpack_public_path__ + "static/media/editImage.29edcc439d56d41af0307ec623c2caec.svg";
export { ForwardRef as ReactComponent };